import { render, staticRenderFns } from "./bannersModule.vue?vue&type=template&id=2ea2310a"
import script from "./bannersModule.vue?vue&type=script&lang=js"
export * from "./bannersModule.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./bannersModule.vue?vue&type=style&index=0&id=2ea2310a&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports